// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"7abfd8ee","543":"9154f55c"}[chunkId] + ".chunk.js";
};